import Icon from '@ant-design/icons';
import { Button, Flex, Form } from 'antd';
import React from 'react';
import CustomFullscreenIcon from '~/assets/svg/icon-fullscreen.svg?react';
import IconLock from '~/assets/svg/icon-lock.svg?react';
import IconNotes from '~/assets/svg/icon-notes.svg?react';
import FullscreenEditorModal from '~/components/screens/Conversations/FullscreenEditorModal';
import SpellCheckerInput from '~/components/shared/SpellCheckerInput/SpellCheckerInput';
import useSendNoteForm from '~/hooks/useSendNoteForm';

function SendNoteForm({ mutation }) {
  const { form, editorRef, setIsModalOpen, onFinish, modalProps } = useSendNoteForm({ mutation });
  const noteIcon = <Icon component={IconNotes} className='text-[24px] shrink-0' />;

  const privateNotice = (
    <Flex gap={8} align='center' className='caption1 text-grey-medium'>
      <Icon component={IconLock} className='text-[24px] shrink-0' />
      <span>Seuls vous, votre équipe et le SAV Label Emmaüs verront ce commentaire</span>
    </Flex>
  );

  return (
    <Flex gap={8} className='w-full'>
      <Form form={form} name='sendNote' onFinish={onFinish} className='w-full'>
        <Flex vertical gap={8}>
          <Flex gap={8}>
            <Form.Item name='content' className='grow'>
              <SpellCheckerInput
                ref={editorRef}
                placeholder='Saisissez votre note interne'
                textArea
                suffix={
                  <Button type='text' className='btn-icon' size='large' onClick={() => setIsModalOpen(true)}>
                    <Icon component={CustomFullscreenIcon} />
                  </Button>
                }
              />
            </Form.Item>
            <Form.Item noStyle>
              <Button type='primary' className='btn-success shrink-0' htmlType='submit' loading={mutation.isPending} disabled={mutation.isPending}>
                Enregistrer
                {!mutation.isPending && noteIcon}
              </Button>
            </Form.Item>
          </Flex>
          {privateNotice}
        </Flex>
      </Form>
      <FullscreenEditorModal {...modalProps} submitIcon={noteIcon}>
        {privateNotice}
      </FullscreenEditorModal>
    </Flex>
  );
}

export default SendNoteForm;
